import { CustomerForm } from '../types/customerForm'
import { getIsAddressExemptionAvailable } from './getIsAddressExemptionAvailable'

type AddressExemptFormValues = Pick<CustomerForm, 'address' | 'customerType' | 'isAddressExempt'>

export const getAddressExemptPayloadValue = (
  { address, customerType, isAddressExempt }: AddressExemptFormValues,
  isFrenchComplianceMode: boolean,
): boolean | undefined => {
  if (!isFrenchComplianceMode) {
    return undefined
  }

  const isAddressExemptionAvailable = getIsAddressExemptionAvailable({
    customerCountry: address?.country,
    customerType,
    isFrenchComplianceMode,
  })

  return isAddressExemptionAvailable && !!isAddressExempt
}
